export default __webpack_public_path__ + "static/feature-data-in-out-04848959ba4cfcf6016801761b62418b.svg";